var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-login-popup"},[_c('img',{staticClass:"icon-logo",attrs:{"src":require("./images/logo.png")}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"btn-login",on:{"click":_vm.handleLogin}},[_vm._v(_vm._s(_vm.btnText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }